import React from 'react';

import type { UserModelType } from '@/models/users';

type UserContextType = {
  me?: UserModelType;
};

const UserContext = React.createContext<UserContextType>({
  me: undefined,
});

export default UserContext;
